module.exports = __webpack_public_path__ + "fonts/miller-displayroman-webfont.72144d8a75d8931d98a99dcff68b3e66.woff";